export default ((env) => {
  switch (env) {
    case "production":
      return {
        newFormId: "222544493831660",
        src: "https://patienteducationgenius.jotform.com",
        autoUpdateDelayInMilliseconds: 600000,
      };
    case "development":
      return {
        // newFormId: '212986469450669',
        newFormId: "222204229762653",
        src: "https://patienteducationgenius.jotform.com",
        autoUpdateDelayInMilliseconds: 600000,
      };
    default:
      return {};
  }
})(process.env.NODE_ENV || "development");
